// extracted by mini-css-extract-plugin
export default {"container":"ObjectEstimateReasonCell_container__XnZls","value":"ObjectEstimateReasonCell_value__hnWOf"};